import {
	DARIO_SYSTEM_DATA_ACTION_TYPES,
	DarioSystemActions,
	DarioSystemData,
} from '../../../../types/darioSystemData'

const initialState: DarioSystemData = {
	firstName: '',
	lastName: '',
	birthDate: null,
}

export default (
	state = initialState,
	action: DarioSystemActions
): DarioSystemData => {
	switch (action.type) {
		case DARIO_SYSTEM_DATA_ACTION_TYPES.DARIO_SYSTEM_SET_DATA: {
			return action.payload
		}

		case DARIO_SYSTEM_DATA_ACTION_TYPES.DARIO_SYSTEM_DATA_PARTIALLY_UPDATE: {
			return {
				...state,
				...action.payload,
			}
		}

		default: {
			return state
		}
	}
}
